import { Link, useLocation } from '@tanstack/react-router'

import { Card, SubnavItem } from '@/components/ui'

interface NavItem {
  label: string
  path: '/credits' | '/credits/usage'
  exact?: boolean
}

const NAV_ITEMS: NavItem[] = [
  { label: 'Buy credits', path: '/credits', exact: true },
  { label: 'Usage', path: '/credits/usage' },
]

export const CreditsNav = () => {
  const { pathname } = useLocation()

  const isActive = ({ path, exact }: NavItem) => {
    if (!exact) return pathname.startsWith(path)

    return pathname === path || pathname === `${path}/`
  }

  return (
    <Card className="bg-muted/30">
      <nav aria-label="Credits sections" className="flex h-10 gap-1 p-1">
        {NAV_ITEMS.map((item) => (
          <SubnavItem key={item.path} asChild active={isActive(item)}>
            <Link to={item.path} preload="intent">
              {item.label}
            </Link>
          </SubnavItem>
        ))}
      </nav>
    </Card>
  )
}
